// Core
import React from "react"

// Styles
import "../../styles/global/global.css"

// Components
import Hero from "./components/Hero"
// import PrimaveraMulher from "./components/PrimaveraMulher"
import Welcome from "./components/Welcome"
import Locations from "./components/Locations"
// import Audition from './components/Audition3'
// import AuditionAcademy from './components/AuditionAcademy'
import Leadership from "./components/Leadership"
import Contribution from "./components/Contribution"
import OnlineSchedule from "./components/OnlineSchedule"
import DownloadApps from "./components/DownloadApps"
import Contact from "./components/Contact"
import Footer from "./components/Footer"

export default function Site() {
  return (
    <>
      <Hero />
      {/* <PrimaveraMulher /> */}
      {/* <Audition /> */}
      {/* <AuditionAcademy /> */}
      <Welcome />
      <Locations />
      <DownloadApps />
      <Leadership />
      <OnlineSchedule />
      <Contribution />
      <Contact />
      <Footer />
    </>
  )
}
